import {GraphQLUniversalProvider} from '@shopify/react-graphql-universal-provider';

import {createClientOptions} from './apollo-client';

export function GraphQL({children}: {children?: React.ReactNode}) {
  return (
    <GraphQLUniversalProvider createClientOptions={createClientOptions}>
      {children}
    </GraphQLUniversalProvider>
  );
}
